var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E48C56A1-FD87-4BC5-B231-5D77F784298F@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.796078 0 0 0 0 0.835294 0 0 0 0 0.878431 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deliver",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#1_Order-Details",
    transform: "translate(-1108.000000, -852.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(351.000000, 673.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information-button",
    transform: "translate(523.000000, 176.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89033333,0 C3.08525,0 0,3.08525 0,6.89033333 C0,10.6954167 3.08525,13.78125 6.89033333,13.78125 C10.6954167,13.78125 13.78125,10.6954167 13.78125,6.89033333 C13.78125,3.08525 10.6954167,0 6.89033333,0 Z M8.32475,10.6790833 C7.97008333,10.8190833 7.68775,10.92525 7.476,10.99875 C7.26483333,11.07225 7.01925,11.109 6.73983333,11.109 C6.3105,11.109 5.97625,11.004 5.73825,10.7945833 C5.50025,10.5851667 5.38183333,10.31975 5.38183333,9.99716667 C5.38183333,9.87175 5.39058333,9.74341667 5.40808333,9.61275 C5.42616667,9.48208333 5.45475,9.33508333 5.49383333,9.17 L5.93775,7.602 C5.97683333,7.4515 6.01066667,7.30858333 6.0375,7.17558333 C6.06433333,7.04141667 6.07716667,6.91833333 6.07716667,6.80633333 C6.07716667,6.60683333 6.03575,6.46683333 5.9535,6.38808333 C5.87008333,6.30933333 5.71316667,6.27083333 5.47925,6.27083333 C5.36491667,6.27083333 5.24708333,6.28775 5.12633333,6.32333333 C5.00675,6.36008333 4.90291667,6.39333333 4.81775,6.426 L4.935,5.943 C5.2255,5.82458333 5.50375,5.72308333 5.76916667,5.63908333 C6.03458333,5.55391667 6.28541667,5.51191667 6.52166667,5.51191667 C6.94808333,5.51191667 7.27708333,5.61575 7.50866667,5.82108333 C7.73908333,6.027 7.85516667,6.29475 7.85516667,6.62375 C7.85516667,6.692 7.847,6.81216667 7.83125,6.98366667 C7.8155,7.15575 7.78575,7.31266667 7.74258333,7.45675 L7.301,9.02008333 C7.26483333,9.1455 7.23275,9.289 7.20358333,9.44941667 C7.175,9.60983333 7.161,9.73233333 7.161,9.81458333 C7.161,10.02225 7.20708333,10.164 7.30041667,10.23925 C7.39258333,10.3145 7.55416667,10.3524167 7.78283333,10.3524167 C7.89075,10.3524167 8.0115,10.3331667 8.148,10.2958333 C8.28333333,10.2585 8.38133333,10.22525 8.44316667,10.1966667 L8.32475,10.6790833 Z M8.24658333,4.33358333 C8.04066667,4.52491667 7.79275,4.62058333 7.50283333,4.62058333 C7.2135,4.62058333 6.96383333,4.52491667 6.75616667,4.33358333 C6.54966667,4.14225 6.44525,3.9095 6.44525,3.63766667 C6.44525,3.36641667 6.55025,3.13308333 6.75616667,2.94 C6.96383333,2.74633333 7.2135,2.65008333 7.50283333,2.65008333 C7.79275,2.65008333 8.04125,2.74633333 8.24658333,2.94 C8.4525,3.13308333 8.55575,3.36641667 8.55575,3.63766667 C8.55575,3.91008333 8.4525,4.14225 8.24658333,4.33358333 Z",
    id: "Shape",
    fill: "#030104",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationButton);
export default __webpack_public_path__ + "a31d96b8780f9b8effbc769d707a3fe9.svg";
export { ForwardRef as ReactComponent };